module.exports = {
      id: "ic-ohlc-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#ic-ohlc-usage",
      toString: function () {
        return this.url;
      }
    }